import { LoadingButton } from "@mui/lab";
import { Alert, IconButton, InputAdornment, Stack, TextField } from "@mui/material";
import { useState } from "react";
import { useLoginMutation } from "src/api/login/login";
import Iconify from "src/components/iconify";
import { StorageKeys } from "src/enums/StorageKeys.enum";

export default function LoginForm() {
	const [showPassword, setShowPassword] = useState(false);
	const [password, setPassword] = useState("");
	const [email, setEmail] = useState("");
	const [error, setError] = useState(null);

	const { mutateAsync, isPending } = useLoginMutation();

	const handleSubmit = () => {
		setError(null);
		mutateAsync({
			email,
			password,
		})
			.then((response) => {
				localStorage.setItem(StorageKeys.token, response?.token);
				window.location.href = "/dashboard/home";
			})
			.catch((error) => {
				setPassword("");
				setEmail("");
				setError(error.response);
			});
	};

	return (
		<form
			onSubmit={(e) => {
				e.preventDefault();
				handleSubmit();
			}}
		>
			<Stack spacing={3}>
				{error !== null ? (
					<Alert sx={{ marginBottom: 2 }} severity="error">
						{`Wrong password`}
					</Alert>
				) : null}

				<TextField
					name="email"
					label="Email address"
					value={email}
					onChange={(e) => {
						setEmail(e.target.value);
					}}
				/>

				<TextField
					name="password"
					label="Password"
					type={showPassword ? "text" : "password"}
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
									<Iconify icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"} />
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
			</Stack>

			<Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}></Stack>

			<LoadingButton
				fullWidth
				size="large"
				type="submit"
				variant="contained"
				disabled={email.length === 0 || password.length === 0}
				loading={isPending}
			>
				Login
			</LoadingButton>
		</form>
	);
}
